/**
 * Function to add debounce time to a function
 * @param {Function} func - function to be debounced
 * @param {number} delay - amount of time to delay in milliseconds
 * @returns {Function}
 */
const debounce = (func, delay) => {
  let timeoutId;
  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func.apply(undefined, args);
    }, delay);
  };
};

export { debounce as d };
//# sourceMappingURL=debounce-BAesZG-J.js.map
